export type ShouldHighlightOptions = {
  startTime: number;
  currentTime: number;
  isRealTimeTranscription: boolean;
};

export const shouldHighlight = (
  active: boolean,
  { startTime, currentTime, isRealTimeTranscription }: ShouldHighlightOptions
) => active && !isRealTimeTranscription && currentTime >= startTime;
